/**
 * 즐겨찾기 API — 입찰 공고 + 기업. 개인별 (인증 필수).
 *
 * - add/remove 는 멱등 → 화면 토글 시점에 낙관적 UI 후 await 안 해도 안전
 * - filter 는 한 화면의 카드들에 별 표시 일괄 조회 — 검색 결과 페이지가 바뀔 때마다 호출
 */
import { api } from "../../../util/api";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

export const favoriteApi = {
    // ── 입찰 공고 ──
    addBid:        (bidAnnouncementId) => api.post(`${API_BASE}/favorites/bids/${bidAnnouncementId}`),
    removeBid:     (bidAnnouncementId) => api.delete(`${API_BASE}/favorites/bids/${bidAnnouncementId}`),
    myBidIds:      ()                  => api.get(`${API_BASE}/favorites/bids`),
    filterBidIds:  (bidAnnouncementIds) => api.post(`${API_BASE}/favorites/bids/filter`, bidAnnouncementIds),

    // ── 기업 ──
    addCompany:        (businessNumber)  => api.post(`${API_BASE}/favorites/companies/${businessNumber}`),
    removeCompany:     (businessNumber)  => api.delete(`${API_BASE}/favorites/companies/${businessNumber}`),
    myCompanyBiznos:   ()                => api.get(`${API_BASE}/favorites/companies`),
    filterCompanyBiznos: (businessNumbers) => api.post(`${API_BASE}/favorites/companies/filter`, businessNumbers),

    // ── 즐겨찾기 탭 — entity 상세까지 ──
    myBidItems:     () => api.get(`${API_BASE}/favorites/bids/items`),
    myCompanyItems: () => api.get(`${API_BASE}/favorites/companies/items`),
};
